export class ListDataCatalogDatasetsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasets",
            "baseName": "datasets",
            "type": "Array<DataCatalogDataset>",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataCatalogDatasetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
